import React from 'react'
import Slide from '../../../react4xp/components/Slide'
import Section from '../../../react4xp/components/Section'


function SlidePart({ title, items }) {
	const data = {
		title,
		slides: items?.map(item => ({
			name: item.name,
			company: item.company,
			position: item.position,
			quote: item.quote,
			image: item.image?.link && { src: item.image.link, alt: item.image.alt },
			video: item.youtubeId ? {
				src: item.youtubeId,
				type: ('youtube' as 'youtube'),
			} : (item.video && {
				src: item.video,
				type: ('default' as 'default'),
			})
		}))
	}

	return (
		<Section bgColor='bg-primary'>
			<Slide {...data} />
		</Section>
	)
}

export default (props) => <SlidePart {...props} />
